import { PracovniPozice } from '@/modules/ciselnik/dilenske/pracovniPozice';

export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'fltOZakazka';
export const NAME = 'Ozakazka';

export const ND = 'NahradniDily';
export const PRACOVNI_POZICE = PracovniPozice.name;
export const PLANNED_ORDER_SERVICE_JOB = 'PlannedOrderServiceJob';
export const MERGE_ZAKAZNIK = 'MergeZakaznik';
export const MERGE_VOZIDLO = 'MergeVozidlo';
export const ZAKAZKY_LIST = 'ZakazkyList';
export const ZAKAZKY_ESHOP_LIST = 'ZakazkyEshopList';
export const SERVICE_PKG_PARTS = 'ServicePackageParts';
export const SERVICE_PKG_LABOR = 'ServicePackageLabor';
export const OZAKAZKA = 'Ozakazka';

export const POLOZKY = 'Polozky';
export const ZAKAZKA_ND_PENDING = 'ZakazkaNdPending';
export const ZAKAZKA_PP_PENDING = 'ZakazkaPracovniPozicePending';
export const MIN_FIELD_LEVEL = 0;
export const MIN_DISCOUNT_LIMIT = 0;
export const MAX_DISCOUNT_LIMIT = 100;
export const CAMPAIGN_DETAILS = 'Campaign';
export const DEFAULT_BRAND = 'V';
export const DATE_FORMAT = 'YYYY/MM/DD';
export const LABOUR_ROW_SAVED = 'Labour Row Saved';
export const LABOUR_ROW_EDITED = 'Labour Row Edited';
export const SAVED = 'Saved';
export const LOADED = 'Loaded';
export const LABOUR_SELECTED = 'Labour Selected';
export const LABOUR_COST_CENTER_CHANGED = 'Labour Cost Center Changed';
export const PLANNED_ORDER_TO_ORDER_CONVERTED = 'Planned Order Converted To Order';

export const DEPENDENT_TABLES = <const>[ND, PRACOVNI_POZICE, ZAKAZKY_LIST, ZAKAZKY_ESHOP_LIST, MERGE_ZAKAZNIK, MERGE_VOZIDLO, SERVICE_PKG_PARTS, SERVICE_PKG_LABOR,
	POLOZKY, ZAKAZKA_ND_PENDING, ZAKAZKA_PP_PENDING, CAMPAIGN_DETAILS, PLANNED_ORDER_SERVICE_JOB];

export enum ZAKAZKA_TYP {
	POPTAVKA_NORA = 1,
	PLANOVANA_ZAKAZKA = 2,
	ESHOP_SKODA = 3,
}

export enum UOM {
	BARREL = 'Barrel',
	LITER = 'Liter',
}

export enum STAV {
	ZAPLANOVANA = 'Zaplanovana',
	V_PRIPRAVE = 'VPriprave',
}
export enum ORDER_STATUS {
	CANCEL = 'C',
	RESCHEDULE = 'R',
}
export type DependentTableNames = typeof DEPENDENT_TABLES[number];

export enum TAB_NAMES {
	HLAVNI = 'Hlavni',
	PRAC = 'Prac',
	POZNAMKY = 'Poznamky',
	ZARAZENI = 'Zarazeni',
	ZAKAZKY = 'Zakazky',
}

export const TABS = {
	[TAB_NAMES.HLAVNI]: { id: TAB_NAMES.HLAVNI, labelKey: 'HlavniUdaje' },
	[TAB_NAMES.PRAC]: { id: TAB_NAMES.PRAC, labelKey: 'tsPPND' },
	[TAB_NAMES.POZNAMKY]: { id: TAB_NAMES.POZNAMKY, labelKey: 'Pozny' },
	[TAB_NAMES.ZARAZENI]: { id: TAB_NAMES.ZARAZENI, labelKey: 'Zarazeni' },
	[TAB_NAMES.ZAKAZKY]: { id: TAB_NAMES.ZAKAZKY, labelKey: 'Zakazky' },
};

export const TEXT = 'TEXT';
export const CAS_JDN_POC = 'CAS_JDN_POC';
export const PP_NR = 'PP_NR';
export const DEALER_NUMBER = 'DEALER_NUMBER';
export const OSOBNI_CIS_PRIJ = 'OSOBNI_CIS_PRIJ';
export const PRACOVNIK_ID = 'PRACOVNIK_ID';
export const LO_DESCRIPTION = 'LO_DESCRIPTION';
export const DISCOUNT_PERCENT = 'DISCOUNT_PERCENT';
export const AMOUNT_WITH_VAT = 'AMOUNT_WITH_VAT';
export const VAT_PERCENTAGE = 'VAT_PERCENTAGE';
export const VAT_AMOUNT = 'VAT_AMOUNT';
export const DISCOUNT_VAL = 'DISCOUNT_VAL';
export const PC_BEZ_DPH_NAD = 'PC_BEZ_DPH_NAD';
export const STREDNAKL_OZN = 'STREDNAKL_OZN';
export const LO_NUMBER = 'LO_NUMBER';
export const SERVICE_JOB_ID = 'SERVICE_JOB_ID';
export const LABOR_ITEM = 'LABOR_ITEM';
export const LABOR_ITEM_TOTAL = 'LABOR_ITEM_TOTAL';
export const PLANNED_ORDER_PARTS_ROW_LENGTH = 1;

export const PRACOVNI_POZICE_COLS = {
	TEXT,
	CAS_JDN_POC,
	OSOBNI_CIS_PRIJ,
	PP_NR,
	DEALER_NUMBER,
	PRACOVNIK_ID,
	LO_DESCRIPTION,
	DISCOUNT_PERCENT,
	DISCOUNT_VAL,
	AMOUNT_WITH_VAT,
	VAT_PERCENTAGE,
	VAT_AMOUNT,
	PC_BEZ_DPH_NAD,
	STREDNAKL_OZN,
	LO_NUMBER,
	SERVICE_JOB_ID,

};

export enum CANCELLATION_REASONS {
	OTHER = 5,
}
export const STOCK = 'STOCK';
export const VYROBEKND_OZN = 'VYROBEKND_OZN';
export const ND_NR = 'ND_NR';
export const PC = 'PC';
export const LOCAL_RRP_ID = 'LOCAL_RRP_ID';
export const UNIT_PRICE_ = 'UNIT_PRICE_';
export const NDP = 'NDP';
export const PART_QUANTITY = 'PART_QUANTITY';
export const NOTE = 'NOTE';
export const BASE_UNIT_OF_MEASUREMENT ='BASE_UNIT_OF_MEASUREMENT';
export const CONVERTED_UNIT_OF_MEASUREMENT ='CONVERTED_UNIT_OF_MEASUREMENT';
export const PRICE_PER_QUANTITY ='PRICE_PER_QUANTITY';
export const RRP_UNIT_PRICE ='RRP_UNIT_PRICE';
export const TECHNICIAN ='TECHNICIAN';

export const ND_COLS = {
	STOCK,
	VYROBEKND_OZN,
	ND_NR,
	TEXT,
	SERVICE_JOB_ID,
	PC,
	LOCAL_RRP_ID,
	UNIT_PRICE_,
	NDP,
	PART_QUANTITY,
	NOTE,
	BASE_UNIT_OF_MEASUREMENT,
	CONVERTED_UNIT_OF_MEASUREMENT,
	PRICE_PER_QUANTITY,
	RRP_UNIT_PRICE,
	TECHNICIAN
};

export enum OrderReports {
	ServiceEstimation = 'SE',
	VehicleReceptionChecklistReport = 'VRC'
}

export const ID = 'ID';
export const SERVICE_JOB_DESCRIPTION = 'SERVICE_JOB_DESCRIPTION';
export const SERVICE_JOB_COMMENTS = 'SERVICE_JOB_COMMENTS';

export const PLANNED_ORDER_SERVICE_JOB_COLS = {
	ID,
	SERVICE_JOB_ID,
	SERVICE_JOB_DESCRIPTION,
	SERVICE_JOB_COMMENTS,
};
